import { Component, OnInit } from '@angular/core';
import {NewsService} from "../../services/news.service";

@Component({
  selector: 'app-more-news',
  templateUrl: './more-news.component.html',
  styleUrls: ['./more-news.component.css']
})
export class MoreNewsComponent implements OnInit {

  noticias: any = [{},{},{},{},{},{}];
  pages: any = [];
  total: any;
  t: number = 0;
  domain:string;
  constructor(private news: NewsService) { }

  ngOnInit() {
    this.getNoticias(0);
    this.news.getConfig().subscribe(response => {
        console.log('FILE_JSON', response);
        this.domain = response.back_domain;
      },
      error => {
        console.log(<any>error);
      });
  }
  getNoticias(page) {


    this.news.getnewsPages(page).subscribe(response => {

        console.log('CONTENT', response);
        this.noticias = response[0];
        this.total = response[1];
        this.total = this.total[0];
        console.log('CONTENT', this.total);
        this.getPages(page);

      },
      error => {
        console.log(<any>error);
      });
  }
  getPages(page) {
    this.pages = [];
    let l: number = 6;
    this.t = this.total.total;
    this.t = Math.trunc(this.t / 6);
    if (page == 0) {
      for(var i = 0; i < 6; i++) {
        this.pages.push(i);
      }
    }else {
      console.log(this.t - page);
      if ((this.t - page) < 6) {
        l = (this.t - page) + 1;
      }else {
        l = 6;
      }
      console.log('L', l);
      for( var i = 0; i < l; i++){
        this.pages.push(i + (page - 1));
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/more-news/more-news.component.ts